export default __webpack_public_path__ + "static/media/virtual_game_banner.0afa5903.png";